export default __webpack_public_path__ + "static/media/Four.b96fcd1b.png";